import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

import StyledTable from '@components/StyledTable'
import { formatDateTime } from '@util/date-util'

import { SidebarLayoutDrawer } from '../../../theme/components/SidebarLayoutDrawer'
import type { HistorySelection } from '../types/HistorySelection'
import type { HoofdnetOpdrachtStatus } from '../types/HoofdnetOpdrachtStatus'
import type { LeveringStatus } from '../types/LeveringStatus'

interface Props {
  history: Array<HoofdnetOpdrachtStatus | LeveringStatus>
  selection: HistorySelection
  open: boolean
  onClose: () => void
}

const headerCells = [
  { id: 'status', numeric: false, label: 'Status' },
  { id: 'changed', numeric: false, label: 'Gewijzigd' },
]

const changedField2statusText = {
  opdracht: 'statusText',
  planning: 'planStatusText',
  levering: 'leveringStatusText',
}

const changedField2title = {
  opdracht: 'Historie van opdracht',
  planning: 'Historie van planning',
  levering: 'Historie van levering',
}

const defaultSort = (x, y) =>
  Number(new Date(y.changed)) - Number(new Date(x.changed))

export const History = ({ history, selection, open, onClose }: Props) => {
  const logToRender = history.filter((item) => {
    if (selection.leveringId) {
      return (item as LeveringStatus).leveringId === selection.leveringId
    }
    return item.changedFields.includes(selection.changedField)
  })

  return (
    <SidebarLayoutDrawer
      open={open}
      onClose={onClose}
      title={changedField2title[selection.changedField]}
      size="sm"
      data-testid="opdrachthoofdnet-historie"
    >
      <StyledTable headerCells={headerCells} {...({} as any)}>
        {[...logToRender].sort(defaultSort).map((item) => {
          const { opdrachtId, changed } = item

          return (
            <TableRow key={`${opdrachtId}-${changed}`}>
              <TableCell>
                {item[changedField2statusText[selection.changedField]]}
              </TableCell>
              <TableCell>{formatDateTime(changed)}</TableCell>
            </TableRow>
          )
        })}
      </StyledTable>
    </SidebarLayoutDrawer>
  )
}
